import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ loading: true });
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) { setState({ loading: false, error: "Missing invite token." }); return; }
    axios.get(`${API}/api/auth/invite/${token}`)
      .then((r) => setState({ loading: false, purpose: r.data.purpose, user: r.data.user }))
      .catch((err) => setState({ loading: false, error: err.response?.data?.detail || "Invite is invalid or expired." }));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 10) { toast.error("Password must be at least 10 characters."); return; }
    if (password !== confirm) { toast.error("Passwords do not match."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/api/auth/accept-invite`, { token, password });
      toast.success("Password set. Please sign in.");
      navigate("/admin/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  if (state.loading) return <div className="bp-container py-16 text-sm">Loading…</div>;
  if (state.error) return (
    <div className="bp-container py-16 max-w-md" data-testid="invite-error">
      <h1 className="font-serif text-3xl mb-4">Invite unavailable</h1>
      <p className="text-sm" style={{ color: "var(--bp-text-muted)" }}>{state.error}</p>
    </div>
  );
  const isReset = state.purpose === "reset";
  return (
    <div className="bp-container py-16 max-w-md" data-testid="accept-invite-page">
      <h1 className="font-serif text-3xl mb-2">{isReset ? "Reset your password" : "Welcome to BrandPassport"}</h1>
      <p className="text-sm mb-6" style={{ color: "var(--bp-text-muted)" }}>
        Setting password for <span className="font-mono">{state.user.email}</span> (role: <span className="font-mono">{state.user.role}</span>)
      </p>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-xs uppercase tracking-widest mb-1" style={{ color: "var(--bp-text-muted)" }}>New password</label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={10} required data-testid="accept-password" />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-widest mb-1" style={{ color: "var(--bp-text-muted)" }}>Confirm password</label>
          <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} minLength={10} required data-testid="accept-confirm" />
        </div>
        <Button type="submit" disabled={busy} data-testid="accept-submit">{busy ? "…" : (isReset ? "Reset password" : "Set password & continue")}</Button>
      </form>
    </div>
  );
}
